import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    cardActionButton: {
        padding: "0px !important",
        display: "flex !important",
        alignItems: "center !important",
        border: "none !important",
        gap: "4px !important",
        "&.MuiButton-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
        },
    },
    cardActionButtonIcon: {
        fontSize: "16px !important",
    },
}));
